import { define, html, router, store } from "hybrids";

import layout from "~/factories/layout";
import infiniteList, { nextPage } from "~/factories/infiniteList";

import ArtistVideo, { sortVideoCollaboratorsGroups } from "~/stores/ArtistVideo";
import Session from "~/stores/Session";

import Donate from "./donate/Root";
import Share from "./Share";
import User from "./User";

interface VVideoPeopleView {
  video?: ArtistVideo;
  relatedVideos: Array<ArtistVideo[]>;
  relatedVideosTag: string;
  session: Session;
}

export default define<VVideoPeopleView>({
  [router.connect]: { url: "/watch/:video", stack: [Donate, User, Share] },
  tag: "v-video-people-view",
  video: store(ArtistVideo),
  relatedVideos: infiniteList(({ video, relatedVideosTag }, page) => {
    return store.get([ArtistVideo], {
      related: true,
      tag: relatedVideosTag,
      id: String(video),
      page,
    });
  }),
  relatedVideosTag: {
    value: "",
    observe(host, value, lastValue) {
      if (value || lastValue) {
        // @ts-ignore
        host.relatedVideos = undefined;
      }
    },
  },
  session: store(Session),
  render: layout("flex"),
content: ({ video, relatedVideos, relatedVideosTag, session }) => {

    if (relatedVideos.length) {
      const rv = relatedVideos[0]

      if (rv.length) {
        document.addEventListener("video-ended", (event) => {
          const nextVideo = rv[0]
          window.location.href = nextVideo.url
        })
      }
    }

    return (
      html`
    <v-broadcast-container overflow grow>
      ${video?.description &&
      html`
        <v-ui-flexbox gap="small">
          <v-broadcast-people-read-more>
            ${video?.description
              .trim()
              .substring(0, 125)
              .split("\n")
              .map((line) => html`
                <v-ui-text>${line}</v-ui-text>`)}
            ${video?.description.length > 125 &&
            video?.description
              .trim()
              .split("\n")
              .map((line) => html`
                <v-ui-text slot="more">${line}</v-ui-text>`)}
          </v-broadcast-people-read-more>
        </v-ui-flexbox>
        <v-broadcast-divider></v-broadcast-divider>
      `}
      ${!!video?.collaboratorsGroups.length &&
      sortVideoCollaboratorsGroups(video?.collaboratorsGroups).map(group =>
        html`
          <v-broadcast-people-section name=${group.name}>
            ${group.collaborators.map((user) =>
              html`
                <v-ui-link href="${router.url(User, { user })}" block>
                  <v-broadcast-user user="${user}" details></v-broadcast-user>
                </v-ui-link>
              `)}
          </v-broadcast-people-section>
          <v-broadcast-divider></v-broadcast-divider>`
      )
      }
      ${!!video?.patrons.length &&
      html`
        <v-broadcast-people-section name="Patrons">
          ${video.patrons
            .filter(
              ({ user }) =>
                !store.ready(session) || !session.blockedUsers.includes(user)
            )
            .map((patron) =>
              html`
                <v-ui-link
                  href="${router.url(User, { user: patron.user })}"
                  block
                >
                  <v-broadcast-user
                    user="${patron.user}"
                    broadcast="${video}"
                    details
                    status="${false}"
                  ></v-broadcast-user>
                </v-ui-link>`.key(patron.user.id)
            )}
        </v-broadcast-people-section>
        <v-broadcast-divider></v-broadcast-divider>
      `}
      ${(!!relatedVideos.length || relatedVideosTag) &&
      html`
        <v-ui-flexbox gap="small">
          <v-broadcast-people-header>
            Related Videos
          </v-broadcast-people-header>
          <v-ui-flexbox gap="medium">
            ${!!video?.tags.length &&
            html`
              <v-ui-flexbox flow="row wrap" gap="small">
                ${["", ...video?.tags].map((tag) =>
                  tag === relatedVideosTag
                    ? html`
                      <v-ui-button
                        variant="inline"
                        type="underline"
                        color="text-secondary"
                        disabled
                        name="${tag.replace(/-/g, " ") || "all"}"
                      ></v-ui-button>`
                    : html`
                      <v-ui-button
                        variant="inline"
                        type="underline"
                        onclick="${html.set("relatedVideosTag", tag)}"
                        name="${tag.replace(/-/g, " ") || "all"}"
                      ></v-ui-button>`
                )}
              </v-ui-flexbox>
            `}
            <v-ui-flexbox gap="medium">
              ${relatedVideos.map(
                (page) =>
                  store.ready(page) &&
                  page.map(
                    (video) =>
                      html`
                        <v-video-card video="${video}"></v-video-card>`
                  )
              )}
              ${!!(relatedVideos.length && relatedVideos[0].length) &&
              html`
                <v-ui-intersect onvisible="${nextPage("relatedVideos")}">
                </v-ui-intersect>
              `}
            </v-ui-flexbox>
          </v-ui-flexbox>
        </v-ui-flexbox>
      `}
    </v-broadcast-container>
  `
)}});
